// extracted by mini-css-extract-plugin
export default {"top-spacing":"Header_top-spacing__bu-Bh","options":"Header_options__i-Fy3","bg-pan-right":"Header_bg-pan-right__P0oPy"};